import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
      path: '/',
      component: () => import('../views/Login'),
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../views/Home'),
      redirect: '/welcome',
      children: [
        {
          // 控制台
          path: '/welcome',
          name: 'welcome',
          component: () => import('../views/Welcome')
        },
        {
          // 数据订单统计
          path: '/statistical_order',
          name: 'statistical_order',
          component: () => import('../views/Statistical/Statistical_Order')
        },
        {
          // 数据用户统计
          path: '/statistical_user',
          name: 'statistical_user',
          component: () => import('../views/Statistical/Statistical_User')
        },
        // {
        //     // 数据充值统计
        //     path: '/statistical_top',
        //     name: 'statistical_top',
        //     component: () => import('../views/Statistical/Statistical_Top')
        // },
        {
          // 数据分成统计
          path: '/statistical_into',
          name: 'statistical_into',
          component: () => import('../views/Statistical/Statistical_Into')
        },
        // 用户管理
        {
          path: '/user',
          name: 'user',
          component: () => import('../views/user/user')
        },
        //代理商管理
        {
          path: '/agentList',
          name: 'agentList',
          component: () => import('../views/agent/agentList')
        }, {
          path: '/agentOrder',
          name: 'agentOrder',
          component: () => import('../views/agent/agentOrder')
        },
        //财务统计
        {
          path: '/financial_top',
          name: 'financial_top',
          component: () => import('../views/Financial/Financial_Top')
        },
        {
          path: '/financial_withdraw',
          name: 'financial_withdraw',
          component: () => import('../views/Financial/Financial_withdraw')
        },
        {
          path: '/wx_set',
          name: 'wx_set',
          component: () => import('../views/system-set/wx_set')
        }, {
          path: '/domain_name',
          name: 'domain_name',
          component: () => import('../views/system-set/domain_name')
        },
        //推广管理
        {
          path: '/novel_extension', //小说推广
          name: 'novel_extension',
          component: () => import('../views/extension/novel_extension')
        }, {
          path: '/novel_extensionLink', //小说推广链接
          name: 'novel_extensionLink',
          component: () => import('../views/extension/novel_extensionLink')
        },
      ]
    },
    {
      path: '/text_extension', //文字文案
      name: 'text_extension',
      component: () => import('../views/extension/text_extension')
    },
    {
      path: '/img_extension',  //图片文案
      name: 'img_extension',
      component: () => import('../views/extension/img_extension')
    },
    {
      path: '/404',
      component:
        () => import('../views/404'),
    }
    ,
    {
      path: '*', redirect:
        '/404',
    }
  ]
;

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    next();
    return
  }
  const tokenStr = sessionStorage.getItem('token');
  if (!tokenStr) {
    next('/');
    return;
  }

  next();
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

export default router
